var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2326_3302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 3.51562H11.2862C11.4863 3.1706 11.6016 2.77049 11.6016 2.34375C11.6016 1.05141 10.5502 0 9.25781 0C8.55829 0 7.92981 0.308408 7.5 0.795967C7.07021 0.308408 6.44171 0 5.74219 0C4.44984 0 3.39844 1.05141 3.39844 2.34375C3.39844 2.77049 3.51363 3.1706 3.71376 3.51562H1.75781C0.788555 3.51562 0 4.30418 0 5.27344V8.08594H1.17188V13.2422C1.17188 14.2114 1.96043 15 2.92969 15H12.0703C13.0396 15 13.8281 14.2114 13.8281 13.2422V8.08594H15V5.27344C15 4.30418 14.2114 3.51562 13.2422 3.51562ZM6.91406 13.8281H2.92969C2.6066 13.8281 2.34375 13.5653 2.34375 13.2422V8.08594H6.91406V13.8281ZM6.91406 6.91406H1.17188V5.27344C1.17188 4.95035 1.43473 4.6875 1.75781 4.6875H6.91406V6.91406ZM6.91406 3.51562H5.74219C5.09602 3.51562 4.57031 2.98992 4.57031 2.34375C4.57031 1.69758 5.09602 1.17188 5.74219 1.17188C6.38836 1.17188 6.91406 1.69758 6.91406 2.34375V3.51562ZM8.08594 2.34375C8.08594 1.69758 8.61164 1.17188 9.25781 1.17188C9.90398 1.17188 10.4297 1.69758 10.4297 2.34375C10.4297 2.98992 9.90398 3.51562 9.25781 3.51562H8.08594V2.34375ZM12.6562 13.2422C12.6562 13.5653 12.3934 13.8281 12.0703 13.8281H8.08594V8.08594H12.6562V13.2422ZM13.8281 6.91406H8.08594V4.6875H13.2422C13.5653 4.6875 13.8281 4.95035 13.8281 5.27344V6.91406Z",
    fill: "#586068"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2326_3302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.bacd43c9d1fff88612199b6dec4549ac.svg";
export { ForwardRef as ReactComponent };